const contactContainer = document.querySelector('.form-sec__contact-container');
if(contactContainer) {
  const tabs = document.querySelectorAll('.form-sec__contact-tab');
  const items = document.querySelectorAll('.form-sec__contact-item');

  tabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => {

      for (let i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('is-active');
        items[i].classList.remove('is-active');
      }

      tab.classList.add('is-active');
      items[idx].classList.add('is-active');
    })
  })
}